import Left from "@repo/icons/default/Left";
import { createFileRoute } from "@tanstack/react-router";
import "@/styles/calendar.css";
import { z } from "zod";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AppointmentAvailableOptionsForm } from "@/components/appointment/appointment-available-options-form";

import type { JSX } from "react";

const appointmentAvailableOptionsPageSearchSchema = z.object({
  locationId: z.number(),
  locationName: z.string(),
  appointmentType: z.number(),
  selectedDate: z.string(),
  selectedTime: z.string(),
  action: z.string().optional(),
  appointmentId: z.number().optional(),
});

const AppointmentAvailableOptions = (): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Novo agendamento" align="center" />
      </HeaderRoot>

      <Page className="px-0">
        <AppointmentAvailableOptionsForm />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/appointment/create/available-options")({
  component: AppointmentAvailableOptions,
  validateSearch: appointmentAvailableOptionsPageSearchSchema,
});
